<div class="wrapper">
  <div class="title-section mb-5">{{"I Progetti"|translate}}</div>

  <!-- [style.backgroundImage]="'url('+ p.titolo_progetto +')'" -->
  <div class="project-wrapper">
    <div class="project-card" *ngFor="let p of projects" [ngStyle]="{'background-image': 'url('+getBackground(p)+')'}"
      (mouseenter)="mouseIn=p.idProject" (mouseleave)="mouseIn=null" (click)="showModalImage(p)">
      <div class="project-title">
        {{p.title}}
      </div>
      <div class="project-info" [ngClass]="{'project-info-show': mouseIn==p.idProject}">
        {{p.description}}
      </div>
    </div>
  </div>
</div>


<div class="modal modal-image" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content modal-xl">
      <div class="modal-body">
        <div class="modal-title flex-space-between">
          <!-- {{"EDIT_ITEM" | translate}} -->
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4">
          <img [src]="getBackground(selectedProject)" class="img-modal-projects" />
        </div>
      </div>
      <div class="modal-footer">
        {{selectedProject.description}}
        <div class="mt-4 h6">{{selectedProject.title}}</div>
      </div>
    </div>
  </div>
</div>